var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.414 11.8693C4.81294 11.0786 6.39305 10.6642 8 10.6667C9.66667 10.6667 11.2313 11.1033 12.586 11.8693M10 6.66667C10 7.1971 9.78929 7.70581 9.41421 8.08088C9.03914 8.45595 8.53043 8.66667 8 8.66667C7.46957 8.66667 6.96086 8.45595 6.58579 8.08088C6.21071 7.70581 6 7.1971 6 6.66667C6 6.13623 6.21071 5.62753 6.58579 5.25245C6.96086 4.87738 7.46957 4.66667 8 4.66667C8.53043 4.66667 9.03914 4.87738 9.41421 5.25245C9.78929 5.62753 10 6.13623 10 6.66667ZM14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircleOutline);
export default __webpack_public_path__ + "static/media/UserCircleOutline.67f4b278b1a40cf5c4e9c81033c83fab.svg";
export { ForwardRef as ReactComponent };